import React from "react"
import ComponentWithData from "~/utils/ComponentWithData"
import {Tenant} from "~/utils/ShelfEntities"
import {
  TitleSection,
  SearchableList,
  ListItemTenant,
  Button
} from "~/components/"
import {withTranslation} from "react-i18next"

class TenantsView extends ComponentWithData {
  getData() {
    Tenant.all()
      .then(tenants => {
        this.setState({data: tenants, resource_loader_state: "successful"})
      })
      .catch(err => {
        console.log("Error loading tenants data: " + err)
      })
  }

  componentDidMount() {
    this.getData()
  }

  update() {
    this.getData()
  }

  getFilteredItems(query) {
    let lowerCaseQuery = query.toLowerCase()
    return this.state.data.filter(tenant =>
      tenant.name.toLowerCase().includes(lowerCaseQuery)
    )
  }

  renderLoading = () => <p>{this.props.t("tenants.loading")}</p>
  renderError = () => <p>{this.props.t("tenants.error")}</p>

  renderWithData() {
    return (
      <React.Fragment>
        <TitleSection>
          <h3>{this.props.t("tenants.title")}</h3>
        </TitleSection>
        <SearchableList
          filteredItems={this.getFilteredItems.bind(this)}
          itemRenderer={ListItemTenant}
          update={this.update.bind(this)}
          renderActions={() => (
            <Button
              primary
              to="/new_tenant"
              icon="plus"
              label={this.props.t("tenants.new")}
            />
          )}
        >
          <p>{this.props.t("tenants.nothing")}</p>
        </SearchableList>
      </React.Fragment>
    )
  }
}

TenantsView.propTypes = {}

export default withTranslation()(TenantsView)



// WEBPACK FOOTER //
// ./src/views/TenantsView.js